import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/store/user'

export function useAuth() {
  const router = useRouter()
  const userStore = useUserStore()

  const isLoggedIn = computed(() => userStore.isLoggedIn)
  const userName = computed(() => userStore.userName)
  const userEmail = computed(() => userStore.userEmail)
  const userInitial = computed(() => {
    if (userStore.userName) return userStore.userName[0].toUpperCase()
    return 'U'
  })

  const logout = async () => {
    await userStore.logout()
    await router.push('/login')
  }

  const checkLogin = () => {
    return userStore.checkLogin()
  }

  const requireAuth = () => {
    if (!checkLogin()) {
      router.push('/login')
      return false
    }
    return true
  }

  return {
    userStore,
    isLoggedIn,
    userName,
    userEmail,
    userInitial,
    logout,
    checkLogin,
    requireAuth
  }
}
